import Image from 'next/image';
import React from 'react';
import { getImageUrl } from '@/lib/imageUrl';
const TestiReviewCommonImages = () => {
  return (
    <div>
      <div className='mb-3 flex items-center justify-center'>
        <div className='z-0 -mr-2 h-[36px] w-[36px] overflow-hidden rounded-full border-[0.5px] border-white bg-gray-300'>
          {/* <Image
            className='h-full w-full object-cover'
            src={getImageUrl('/common/testimonials/testi_demo%20(1).webp')}
            width={200}
            height={200}
            alt='Avatar 1'
          /> */}
          <Image
            src={getImageUrl('/vilvabusiness/website/common/testimonials/testi_demo%20(1).webp')}
            alt='Customer testimonial avatar'
            width='1200'
            height='675'
            className='h-auto w-full object-contain'
            loading='eager'
            decoding='async'
          />
        </div>
        <div className='relative z-10 h-[36px] w-[36px] overflow-hidden rounded-full border-[0.5px] border-white'>
          {/* <Image
            className='h-full w-full object-cover'
            src={getImageUrl('/common/testimonials/testi_demo%20(1).webp')}
            width={200}
            height={200}
            alt='Avatar 2'
          /> */}
          <Image
            src={getImageUrl('/vilvabusiness/website/common/testimonials/testi_demo%20(2).webp')}
            alt='Customer testimonial avatar'
            width='1200'
            height='675'
            className='h-auto w-full object-contain'
            loading='eager'
            decoding='async'
          />
        </div>
        <div className='z-20 -ml-2 h-[36px] w-[36px] overflow-hidden rounded-full border-[0.5px] border-white bg-gray-300'>
          {/* <Image
            className='h-full w-full object-cover'
            src={getImageUrl('/common/testimonials/testi_demo%20(3).webp')}
            width={200}
            height={200}
            alt='Avatar 3'
          /> */}
          <Image
            src={getImageUrl('/vilvabusiness/website/common/testimonials/testi_demo%20(3).webp')}
            alt='Customer testimonial avatar'
            width='1200'
            height='675'
            className='h-auto w-full object-contain'
            loading='eager'
            decoding='async'
          />
        </div>
        <div className='z-30 -ml-2 h-[36px] w-[36px] overflow-hidden rounded-full border-[0.5px] border-white bg-gray-300'>
          {/* <Image
            className='h-full w-full object-cover'
            src={getImageUrl('/common/testimonials/testi_demo%20(4).webp')}
            width={200}
            height={200}
            alt='Avatar 4'
          /> */}

          <Image
            src={getImageUrl('/vilvabusiness/website/common/testimonials/testi_demo%20(4).webp')}
            alt='Customer testimonial avatar'
            width='1200'
            height='675'
            className='h-auto w-full object-contain'
            loading='eager'
            decoding='async'
          />
        </div>
      </div>
    </div>
  );
};

export default TestiReviewCommonImages;
